import { agentAttachmentSchema, toolDeclarationSchema } from '@teo/types';
import { z } from 'zod';
export const turnAttachmentSchema = agentAttachmentSchema.extend({ storagePath: z.string() });
export const turnSetupSchema = z.object({
    userId: z.number(),
    questionEntryId: z.number(),
    text: z.string(),
    attachments: z.array(turnAttachmentSchema),
    systemInstruction: z.string(),
    preamble: z.string(),
    declarations: z.array(toolDeclarationSchema),
    surfaceHash: z.string(),
});
//# sourceMappingURL=agentTurn.js.map